module.exports = __webpack_public_path__ + "static/media/HCMM326.a67e94f0.jpg";